import { OAuthInteractionRO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";

const getOAuthInteraction = async (
  interactionId: string,
): Promise<OAuthInteractionRO> => {
  const { data } = await apiService.get<OAuthInteractionRO>(
    Endpoints.OAuth.Interactions.Get(interactionId),
  );

  return data;
};

const getOAuthDecisionUrl = (interactionId: string): string =>
  `${process.env.VITE_REACT_APP_API_URL ?? ""}${Endpoints.OAuth.Interactions.Decision(
    interactionId,
  )}`;

export { getOAuthDecisionUrl, getOAuthInteraction };
